export const brands = [
  "/assets/images/demo-fancy/logotypes/client-1.png",
  "/assets/images/demo-fancy/logotypes/client-2.png",
  "/assets/images/demo-fancy/logotypes/client-3.png",
  "/assets/images/demo-fancy/logotypes/client-4.png",
  "/assets/images/demo-fancy/logotypes/client-5.png",
  "/assets/images/demo-fancy/logotypes/client-6.png",
  "/assets/images/demo-fancy/logotypes/client-1.png",
  "/assets/images/demo-fancy/logotypes/client-2.png",
];
export const brandsDark = [
  "/assets/images/demo-fancy/logotypes/dark/client-1.png",
  "/assets/images/demo-fancy/logotypes/dark/client-2.png",
  "/assets/images/demo-fancy/logotypes/dark/client-3.png",
  "/assets/images/demo-fancy/logotypes/dark/client-4.png",
  "/assets/images/demo-fancy/logotypes/dark/client-5.png",
  "/assets/images/demo-fancy/logotypes/dark/client-6.png",
  "/assets/images/demo-fancy/logotypes/dark/client-1.png",
  "/assets/images/demo-fancy/logotypes/dark/client-2.png",
];

export const clients = [
  {
    id: 1,
    src: "/assets/images/clients-logos/logo-grid-dark/logo-1.png",
    width: 110,
    height: 33,
    alt: "Image description is here",
  },
  {
    id: 2,
    src: "/assets/images/clients-logos/logo-grid-dark/logo-2.png",
    width: 119,
    height: 33,
    alt: "Image description is here",
  },
  {
    id: 3,
    src: "/assets/images/clients-logos/logo-grid-dark/logo-3.png",
    width: 79,
    height: 33,
    alt: "Image description is here",
  },
  {
    id: 4,
    src: "/assets/images/clients-logos/logo-grid-dark/logo-4.png",
    width: 122,
    height: 33,
    alt: "Image description is here",
  },
];

export const clients2 = [
  {
    id: 1,
    imgSrc: "/assets/images/clients-logos/with-bg/client-1.jpg",
    name: "Noresto",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: "0s",
  },
  {
    id: 2,
    imgSrc: "/assets/images/clients-logos/with-bg/client-2.jpg",
    name: "Bederico",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: ".1s",
  },
  {
    id: 3,
    imgSrc: "/assets/images/clients-logos/with-bg/client-3.jpg",
    name: "Furfuchs",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: ".2s",
  },
  {
    id: 4,
    imgSrc: "/assets/images/clients-logos/with-bg/client-4.jpg",
    name: "Amore",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: "0s",
  },
  {
    id: 5,
    imgSrc: "/assets/images/clients-logos/with-bg/client-5.jpg",
    name: "Ferir",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: ".1s",
  },
  {
    id: 6,
    imgSrc: "/assets/images/clients-logos/with-bg/client-6.jpg",
    name: "Jean La Moni",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: ".2s",
  },
];

export const careerbenefits = [
  {
    id: 1,
    imgSrc: "/assets/images/clients-logos/with-bg/client-1.jpg",
    name: "5 Days working",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: "0s",
  },
  {
    id: 2,
    imgSrc: "/assets/images/clients-logos/with-bg/client-2.jpg",
    name: "Bederico",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: ".1s",
  },
  {
    id: 3,
    imgSrc: "/assets/images/clients-logos/with-bg/client-3.jpg",
    name: "Furfuchs",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: ".2s",
  },
  {
    id: 4,
    imgSrc: "/assets/images/clients-logos/with-bg/client-4.jpg",
    name: "Amore",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: "0s",
  },
  {
    id: 5,
    imgSrc: "/assets/images/clients-logos/with-bg/client-5.jpg",
    name: "Ferir",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: ".1s",
  },
  {
    id: 6,
    imgSrc: "/assets/images/clients-logos/with-bg/client-6.jpg",
    name: "Jean La Moni",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: ".2s",
  },
];

export const clients3 = [
  {
    id: 1,
    imgSrc: "/assets/images/clients-logos/client-1.png",
    name: "Noresto",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: "0s",
  },
  {
    id: 2,
    imgSrc: "/assets/images/clients-logos/client-2.png",
    name: "Bederico",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: ".1s",
  },
  {
    id: 3,
    imgSrc: "/assets/images/clients-logos/client-3.png",
    name: "Furfuchs",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: ".2s",
  },
  {
    id: 4,
    imgSrc: "/assets/images/clients-logos/client-4.png",
    name: "Amore",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: "0s",
  },
  {
    id: 5,
    imgSrc: "/assets/images/clients-logos/client-5.png",
    name: "Ferir",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: ".1s",
  },
  {
    id: 6,
    imgSrc: "/assets/images/clients-logos/client-6.png",
    name: "Jean La Moni",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: ".2s",
  },
];


export const sliderclients = [
  {
    id: 1,
    imgSrc: "/assets/images/clients-logos/c1.webp",
    name: "Noresto",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: "0s",
  },
  {
    id: 2,
    imgSrc: "/assets/images/clients-logos/c2.webp",
    name: "Bederico",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: ".1s",
  },
  {
    id: 3,
    imgSrc: "/assets/images/clients-logos/c3.webp",
    name: "Furfuchs",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: ".2s",
  },
  {
    id: 4,
    imgSrc: "/assets/images/clients-logos/c4.webp",
    name: "Amore",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: "0s",
  },
  {
    id: 5,
    imgSrc: "/assets/images/clients-logos/c5.webp",
    name: "Ferir",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: ".1s",
  },
  {
    id: 6,
    imgSrc: "/assets/images/clients-logos/c6.webp",
    name: "Jean La Moni",
    description:
      "Lorem ipsum dolor sit amet adipiscing elit. In maximus ligula semper metus pellentesque mattis. Maecenas volutpat, diam enim.",
    delay: ".2s",
  },
];